import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import Select from 'react-select'
import autobind from 'autobind-decorator'
import _ from 'lodash'
import RequiredLabel from './requiredLabel'
import { getObjVal, isEmpty } from '../utils'
import { hiddenFields } from '../constants'
import {
  VISIT_PURPOSE_OPTIONS,
  HOW_DID_YOU_HEAR_OPTIONS,
  WHAT_MOTIVATED_YOUR_VISIT_OPTIONS
} from '../components/dropdownOptions'
import Input from '../components/elements/input'

function buildSelectOptions(options) {
  return options.map(x => ({ label: x, value: x }))
}

function buildInputField(args) {
  let {
    label,
    props,
    width,
    colMdWidth,
    colLgWidth,
    colSmWidth,
    indx,
    required
  } = args
  return indx < 0 ? (
    <Col
      md={colMdWidth || width}
      sm={colSmWidth || 4}
      xs={12}
      lg={colLgWidth || width}
    >
      <Input
        {...props}
        type='text'
        value={getObjVal(props)}
        label={<RequiredLabel label={label} required={required} />}
        required={required}
        help={(props.touched && props.error) || ''}
        helpClassName='error'
        bsStyle={props.touched && props.error ? 'error' : null}
      />
    </Col>
  ) : null
}

@autobind
class SelectInput extends Component {
  static defaultProps = {
    clearable: false,
    colMdWidth: 12,
    colLgWidth: 6,
    required: false
  }

  static propTypes = {
    field: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    clearable: PropTypes.bool,
    colWidth: PropTypes.number,
    required: PropTypes.bool
  }

  render() {
    let {
      field,
      value,
      label,
      clearable,
      colMdWidth,
      colLgWidth,
      options,
      required,
      ...selectProps
    } = this.props
    let selectOptions = buildSelectOptions(options)
    return (
      <Col xs={12} sm={12} md={colMdWidth} lg={colLgWidth}>
        <Input
          label={<RequiredLabel label={label} required={required} />}
          help={field.touched && field.error}
          bsStyle={field.touched && field.error ? 'error' : null}
        >
          <Select
            {...selectProps}
            value={value || field.value}
            onChange={field.onChange}
            options={selectOptions}
            clearable={clearable}
          />
        </Input>
      </Col>
    )
  }
}

class SelectInputWithOther extends Component {
  static defaultProps = {
    otherColWidth: 6,
    colLgWidth: 6,
    colMdWidth: 12,
    colSmWidth: 12
  }

  static propTypes = {
    otherField: PropTypes.object.isRequired,
    otherLabel: PropTypes.string.isRequired,
    otherColWidth: PropTypes.number,
    colLgWidth: PropTypes.number,
    colMdWidth: PropTypes.number,
    colSmWidth: PropTypes.number
  }

  render() {
    let {
      otherField,
      otherLabel,
      otherColWidth,
      colLgWidth,
      colMdWidth,
      colSmWidth,
      ...selectInputProps
    } = this.props
    let otherInput =
      selectInputProps.field.value === 'Other'
        ? buildInputField({
            label: otherLabel,
            props: otherField,
            width: otherColWidth,
            colMdWidth: colMdWidth,
            colLgWidth: colLgWidth,
            colSmWidth: colSmWidth,
            indx: -1
          })
        : null
    return (
      <div>
        <SelectInput {...selectInputProps} />
        {otherInput}
      </div>
    )
  }
}

@autobind
export default class GuestEntryCommonInputs extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired
  }

  render() {
    let {
      fields: {
        address: { street, city, state, zip, country },
        howDidYouHear,
        howDidYouHearOther,
        visitComment,
        visitPurpose,
        whatMotivated,
        whatMotivatedOther,
        peopleTakenIshaProgram,
        firstTimeVisits,
        volunteerHandlingBooking,
        email
      },
      authenticated
    } = this.props
    let fieldArgs = [
      {
        label: 'Street',
        props: street,
        width: 3,
        indx: hiddenFields.indexOf('street'),
        required: true
      },
      {
        label: 'City',
        props: city,
        width: 3,
        indx: hiddenFields.indexOf('city'),
        required: true
      },
      {
        label: 'State',
        props: state,
        width: 2,
        indx: hiddenFields.indexOf('state'),
        required: true
      },
      {
        label: 'Zip Code',
        props: zip,
        width: 2,
        indx: hiddenFields.indexOf('zip'),
        required: true
      },
      {
        label: 'Country',
        props: country,
        width: 2,
        indx: hiddenFields.indexOf('country'),
        required: true
      }
    ]
    let commentArgs = {
      label: 'Visit comment',
      props: visitComment,
      width: 6,
      indx: -1,
      required: false
    }
    let fieldElements = fieldArgs.map(args => buildInputField(args))
    // Authenticated-user/Staff-member can see all common fields except address fields
    // Authenticated-user/Staff-member can see all common fields except address fields
    return (
      <form>
        <Row>{fieldElements}</Row>
        {authenticated ? (
          <div>
            {hiddenFields.indexOf('visitPurpose') < 0 ? (
              <Row>
                <SelectInput
                  value={getObjVal(visitPurpose.value)}
                  field={visitPurpose}
                  options={VISIT_PURPOSE_OPTIONS}
                  label='Visit Purpose'
                  multi={true}
                  delimiter=';'
                  required={authenticated}
                />
                {buildInputField(commentArgs)}
              </Row>
            ) : null}
            {hiddenFields.indexOf('howDidYouHear') < 0 ? (
              <Row>
                <SelectInputWithOther
                  value={getObjVal(howDidYouHear.value)}
                  field={howDidYouHear}
                  options={HOW_DID_YOU_HEAR_OPTIONS}
                  label='How did you hear about Isha'
                  otherField={howDidYouHearOther}
                  otherLabel='How did you hear about Isha (Other)'
                />
              </Row>
            ) : null}
            {hiddenFields.indexOf('whatMotivated') < 0 ? (
              <Row>
                <SelectInputWithOther
                  value={getObjVal(whatMotivated.value)}
                  field={whatMotivated}
                  options={WHAT_MOTIVATED_YOUR_VISIT_OPTIONS}
                  label='What motivated your visit to iii today?'
                  otherField={whatMotivatedOther}
                  otherLabel='What motivated your visit to iii today? (Other)'
                  required={false}
                />
              </Row>
            ) : null}
            <Row>
              {hiddenFields.indexOf('peopleTakenIshaProgram') < 0 ? (
                <SelectInput
                  value={getObjVal(peopleTakenIshaProgram.value)}
                  field={peopleTakenIshaProgram}
                  options={_.range(20).map(String)}
                  label='People in your group taken Isha Program?'
                  required={false}
                />
              ) : null}
              {hiddenFields.indexOf('firstTimeVisits') < 0 ? (
                <SelectInput
                  value={getObjVal(firstTimeVisits.value)}
                  field={firstTimeVisits}
                  label='How many are visiting 1st time to iii?'
                  options={_.range(20).map(String)}
                  required={false}
                />
              ) : null}
            </Row>
            <Row>
              {hiddenFields.indexOf('volunteerHandlingBooking') < 0
                ? buildInputField({
                    label: (
                      <RequiredLabel
                        label='Volunteer Handling Booking'
                        required={true}
                      />
                    ),
                    width: 6,
                    props: volunteerHandlingBooking,
                    indx: -1
                  })
                : null}
            </Row>
          </div>
        ) : null}
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/guestEntryCommonInputs.js